export const COMMUNITY_PRESENCE_ONLINE_WINDOW_MS = 5 * 60 * 1000;

export function isCommunityMemberOnline(
  lastActiveAt: Date | string | null | undefined,
  now = Date.now(),
): boolean {
  if (!lastActiveAt) return false;
  const timestamp = lastActiveAt instanceof Date ? lastActiveAt.getTime() : Date.parse(lastActiveAt);
  if (!Number.isFinite(timestamp)) return false;
  return now - timestamp <= COMMUNITY_PRESENCE_ONLINE_WINDOW_MS;
}

export function formatCommunityMemberLastActive(
  lastActiveAt: Date | string | null | undefined,
  now = Date.now(),
): string | null {
  if (!lastActiveAt) return null;
  const timestamp = lastActiveAt instanceof Date ? lastActiveAt.getTime() : Date.parse(lastActiveAt);
  if (!Number.isFinite(timestamp)) return null;

  const diffMs = Math.max(now - timestamp, 0);
  if (diffMs <= COMMUNITY_PRESENCE_ONLINE_WINDOW_MS) return 'Online';

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return `Active ${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Active ${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days === 1) return 'Active yesterday';
  if (days < 7) return `Active ${days}d ago`;

  return `Last active ${new Date(timestamp).toLocaleDateString()}`;
}

export function mapCommunityMemberPresence(
  lastActiveAt: Date | string | null | undefined,
  options?: { hideLastActive?: boolean },
) {
  const hidden = options?.hideLastActive === true;
  return {
    lastActiveAt:
      lastActiveAt instanceof Date
        ? lastActiveAt.toISOString()
        : lastActiveAt ?? null,
    isOnline: hidden ? false : isCommunityMemberOnline(lastActiveAt),
    lastActiveLabel: hidden ? null : formatCommunityMemberLastActive(lastActiveAt),
    hideLastActive: hidden,
  };
}
